// src/pages/ProductInfo.jsx

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProductDetailsPublic } from '../../services/productsServices';
import { getVendedorCreadorInventario } from '../../services/inventoryServices';
import HeaderBar from '../../components/LoggedOut/HeaderLogic/HeaderBar';
import SendMessage from '../../components/LoggedOut/SendMessage';
import FooterGuest from '../../components/Shared/FooterGuest';
import LoadingSpinner from '../../components/Shared/LoadingSpinner';
import { Grid, Descriptions, Tag, Divider, Card } from 'antd';
import '../../styles/ProductInfo.css';

export default function ProductInfo() {
  const { fcNombre, fiProducto } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [vendedor, setVendedor] = useState(null);
  const [error, setError] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Para HeaderBar:
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [searchText, setSearchText] = useState('');
  const [favoritesCount] = useState(0);

  const handleSearch = () => {};
  const openFavoritesDrawer = () => {};
  const handleLogin = () => { navigate('/login'); };
  const handleContactos = () => { navigate('/contacto'); };
  const toggleFilterDrawer = () => {};
  const toggleMenuDrawer = () => {};

  useEffect(() => {
    const fetchDatos = async () => {
      try {
        const data = await getProductDetailsPublic(fiProducto);

        if (data) {
          setProduct(data);
          setSelectedImage(data.images?.[0] || null);

          const fiInventarioFromProduct = data.FIInventario;
          if (fiInventarioFromProduct) {
            const vendedorData = await getVendedorCreadorInventario(fiInventarioFromProduct);
            setVendedor(vendedorData.vendedor);
          } else {
            setVendedor(null);
          }
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Error al cargar producto o vendedor:", err);
        setError(true);
      }
    };

    if (fiProducto) {
      fetchDatos();
    }
  }, [fiProducto]);

  if (error) {
    return <p>❌ No se encontró el producto o hubo un error al cargarlo.</p>;
  }

  if (!product || (product.FIInventario && !vendedor)) {
    return <LoadingSpinner message="Cargando detalles del producto..." />;
  }

  console.log(product)
  return (
    <div className="product-info-layout">
      {/* Header fijo */}
      <HeaderBar
        isMobile={isMobile}
        searchText={searchText}
        onSearchTextChange={setSearchText}
        handleSearch={handleSearch}
        favoritesCount={favoritesCount}
        openFavoritesDrawer={openFavoritesDrawer}
        handleLogin={handleLogin}
        handleContactos={handleContactos}
        toggleFilterDrawer={toggleFilterDrawer}
        toggleMenuDrawer={toggleMenuDrawer}
      />

      <div className="product-detail-page">
        {/* ─── Columna de imágenes ───────────────────────────────────────────── */}
        <div className="image-column">
          <Card className="image-card" bordered={false}>
            <div className="main-image">
              <img src={selectedImage} alt={product.FCNombre} />
            </div>
            <div className="thumbnail-list">
              {product.images?.slice(0, 5).map((imgUrl, index) => (
                <img
                  key={index}
                  src={imgUrl}
                  alt={`Miniatura ${index + 1}`}
                  onClick={() => setSelectedImage(imgUrl)}
                  className={imgUrl === selectedImage ? 'thumbnail active' : 'thumbnail'}
                />
              ))}
            </div>
          </Card>
        </div>

        {/* ─── Columna de información ─────────────────────────────────────────── */}
        <div className="info-column">
          
          {/* ─ Datos generales del producto ──────────────────────────────────── */}
          <Card className="product-info-card" bordered={false}>
            <h1 className="product-title">{product.FCNombre}</h1>
            <Divider />

            <Descriptions
              bordered
              column={1}
              size="middle"
              layout="horizontal"
              labelStyle={{ fontWeight: 600, width: isMobile ? '40%' : '30%' }}
              contentStyle={{ width: isMobile ? '60%' : '70%' }}
            >
              <Descriptions.Item label="Marca">
                {product.marcas?.map(m => m.FCNombre).join(', ')}
              </Descriptions.Item>
              <Descriptions.Item label="Precio">
                ${product.FNPrecioVenta}
              </Descriptions.Item>
              <Descriptions.Item label="Cantidad disponible">
                {product.FNCantidad}
              </Descriptions.Item>
              <Descriptions.Item label="Fecha de compra">
                {product.FDFechaCompra || 'Sin fecha registrada'}
              </Descriptions.Item>
              <Descriptions.Item label="Estatus">
                {product.FIEstatus ? 'Activo' : 'Inactivo'}
              </Descriptions.Item>
              <Descriptions.Item label="Descripción">
                {product.FCDescripcion || 'No hay descripción disponible.'}
              </Descriptions.Item>
            </Descriptions>

            {/* Categorías como tags */}
            {product.categorias && Object.keys(product.categorias).length > 0 && (

              <>
                <Divider />
                <div className="categories-section">
                  <h3 className="section-subtitle">Categorías vigentes</h3>
                  <div className="category-tags">
                    {Object.entries(product.categorias).map(([catName, valores]) =>
                      valores.map(v => (
                        <div>
                        <Tag color="magenta" key={v.FIValorCategoria}>
                          {catName}: {v.categoria_nombre}   
                        </Tag>
                        <Tag color="blue" key={v.FIValorCategoria}>
                        Disponibilidad: {v.FnCantidad}
                        </Tag>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </>
            )}

            {/* Botón para enviar mensaje */}
            <Divider />
            <div className="action-section">
              <SendMessage product={product} vendedor={vendedor} />
            </div>
          </Card>
        </div>
      </div>

      {/* Footer fijo */}
      <FooterGuest className="footer-guest" />
    </div>
  );
}
